/**
 * T138479 - We Love Savings FPA layout change
 * Script runs on update of finance calculator within FPA Values are passed in via twig
 * from item on page load and updated on update of finance calculator to get new savings
 * based on params
 *
 * twig template(s):-
 * - shop/item/savings_breakdown.twig
 */
export const getUpdatedSavingValues = (data) => {
    $.ajax({
        url: '/sites/petervardy/templates/ajax/item/savings-breakdown.php',
        type: 'post',
        dataType: 'json',
        data,
        success(res) {
            let values = {}
            let total

            if (res && Object.keys(res).length) {
                for (const [key, obj] of Object.entries(res)) {
                    if (key === 'total'){
                        total = obj
                    } else {
                        values[key] = obj
                    }
                }
            }

            updateSavingValues(values, total)
        }
    })
}

const updateSavingValues = (values, total) => {
    const itemSavingsEl = document.querySelector('.js_itemSavingsBreakdown');
    const itemSavingsBodyEl = itemSavingsEl.querySelector('.itemSavingsBreakdown__body')
    const itemSavingsTitleStraplineEl = itemSavingsEl.querySelector('.itemSavingsBreakdown__title__strapline')

    if (!itemSavingsEl || !itemSavingsBodyEl) {
        return
    }

    itemSavingsEl.classList.contains('itemSavingsBreakdown--hidden') && itemSavingsEl.classList.remove('itemSavingsBreakdown--hidden')

    // Remove all current saving items
    while (itemSavingsBodyEl.firstElementChild) {
        itemSavingsBodyEl.firstElementChild.remove()
    }

    // We use this to check total number of values which are above 0 (not hidden)
    const valuesAboveZero = countValesAboveZero(values)
    const savingItems = []

    for (const [_, obj] of Object.entries(values)) {

        const { value, label, single_showing_label } = obj

        // If value is greater than 0, we add the saving
        if (value > 0) {
            const savingEl = document.createElement('div')
            savingEl.className = 'itemSavingsBreakdown__savingItem'

            // if only 1 item with a value above 0, we show a different state
            if (valuesAboveZero === 1) {
                // we want to show only the single showing text
                savingEl.classList.add('itemSavingsBreakdown__savingItem--single')

                const savingSingleEl = document.createElement('span')
                savingSingleEl.className = 'itemSavingsBreakdown__single'
                savingSingleEl.innerHTML = single_showing_label

                const savingSingleSpanEl = savingSingleEl.querySelector('span')
                savingSingleSpanEl.innerHTML = '&pound' + value

                savingEl.append(savingSingleEl)

            } else {
                const savingLabelEl = document.createElement('span')
                savingLabelEl.className = 'itemSavingsBreakdown__label'
                savingLabelEl.innerHTML = label

                const savingValueEl = document.createElement('span')
                savingValueEl.className = 'itemSavingsBreakdown__value'
                savingValueEl.innerHTML = '&pound;' + value

                savingEl.prepend(savingLabelEl)
                savingEl.append(savingValueEl)
            }

            savingItems.push(savingEl)
        }
    }

    // Create the savings element and prepend it to the body el
    const itemSavingsSavingsEl = document.createElement('div')
    itemSavingsSavingsEl.className = 'itemSavingsBreakdown__savings'
    itemSavingsSavingsEl.replaceChildren(...savingItems)

    itemSavingsBodyEl.prepend(itemSavingsSavingsEl)

    // We only show the total if items are greater than 1
    if (savingItems.length > 1) {
        // Create total el
        const itemSavingsTotalEl = document.createElement('div')
        itemSavingsTotalEl.className = 'itemSavingsBreakdown__total'

        const itemSavingsTotalLabelEl = document.createElement('span')
        itemSavingsTotalLabelEl.className = 'itemSavingsBreakdown__label itemSavingsBreakdown__label--bold'
        itemSavingsTotalLabelEl.innerHTML = total.label

        const itemSavingsTotalValueEl = document.createElement('span')
        itemSavingsTotalValueEl.className = 'itemSavingsBreakdown__value itemSavingsBreakdown__value--large'
        itemSavingsTotalValueEl.innerHTML = '&pound;' + total.value

        itemSavingsTotalEl.prepend(itemSavingsTotalLabelEl)
        itemSavingsTotalEl.append(itemSavingsTotalValueEl)

        itemSavingsBodyEl.append(itemSavingsTotalEl)
    }

    toggleStrapline(itemSavingsTitleStraplineEl, valuesAboveZero)
    toggleSavingsBodyElSpacing(itemSavingsBodyEl, valuesAboveZero)

}

/**
 * Looks through the values received from ajax and if greater than 0, increases the count. This is used for updating state for class names and generating markup.
 *
 * @param values
 * @returns number
 */
const countValesAboveZero = (values) => {
    let count = 0

    for (const [_, obj] of Object.entries(values)) {
        if (obj.value > 0) {
            count++
        }
    }

    return count
}

/**
 * Handles adding and removing spacing for body to be inline with the title based on values above zero.
 *
 * @param el
 * @param count
 */
const toggleSavingsBodyElSpacing = (el, count) => {
    const modifierClass = 'itemSavingsBreakdown__body--spacing';

    if (!el) {
        return;
    }

    if (count < 3) {
        !el.classList.contains(modifierClass) && el.classList.add(modifierClass)
        return
    }

    el.classList.contains(modifierClass) && el.classList.remove(modifierClass)
}

/**
 * Handles adding and removing hidden class for strapline based on values above zero.
 *
 * @param el
 * @param count
 */
const toggleStrapline = (el, count) => {
    const modifierClassName = 'itemSavingsBreakdown__title__strapline--hidden'

    if (!el) {
        return;
    }

    if (count === 1) {
        !el.classList.contains(modifierClassName) && el.classList.add(modifierClassName)
        return
    }

    el.classList.contains(modifierClassName) && el.classList.remove(modifierClassName)
}